import Default from './default';


const CTA = {
  Default,
 
};

export default CTA;